<template>
    <span>
        <v-btn icon @click="requestDeleteConfirm()"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
        <confirm-dialog :open="confirmDelete.open" :header="confirmDelete.header"
                        :question="confirmDelete.question" :without-router="true"
                        @reply="processConfirm" :query-parameter="'confirmSpielfreiDelete'+item.id">
        </confirm-dialog>
    </span>
</template>

<script>
    import ConfirmDialog from "../../components/navigation/confirmDialog";
    import {firestore} from "../../services/db";

    export default {
        components: {
            ConfirmDialog},
        name: "spiel-plan-frei-delete",
        props: ['item', 'runde', 'saison'],
        data: () => ({
            confirmDelete: {
                open: false,
                question: '',
                item: null,
            },
        }),
        methods: {
            requestDeleteConfirm(){
                this.confirmDelete.header = 'Spielfrei löschen';
                this.confirmDelete.question = "Möchtest du die Mannschaft '" + this.item.name +
                    "' wirklich aus der Liste der spielfreien Mannschaften für diese Runde löschen?";
                this.confirmDelete.open = true;
            },
            processConfirm(reply) {
                if ( reply ) {
                    this.processDeletion();
                }
                this.confirmDelete.open = false;
            },
            async processDeletion(){
                this.$store.state.local.loader = true;
                console.log ("this.runde", this.runde);
                console.log ("this.item.id", this.item.id);
                const key = 'spielfrei.' + this.getRundenKey() + '.' + this.item.id;
                this.saison.local.documentUpdates = {
                    [key]: firestore.FieldValue.delete(),
                };
                const reply = await this.saison.saveEdited('saison_edit');
                if ( reply.successful ) {
                    this.$store.state.local.loader = false;
                } else {
                    this.$store.state.local.loader = false;
                    this.error = this.dataObject.getDBErrorText(reply.content);
                }
            },
                getRundenKey(){
                    // looks like 01.03/3 H => 01.03 is for sorting
                    const rundenKey = this.runde.split('/');
                    return rundenKey[1].replace(' ', '_')
                }
        },
    }

</script>

<style scoped>

</style>